import { put, call } from 'redux-saga/effects'

import AuthActions from '../models/auth'
import { amplifyAuthentication, amplifySignup, confirmSignUp } from 'awsApi'
import { Auth } from 'aws-amplify'
import { ERROR_MESSAGES } from '@wellbeingxltd/fe-lib/constants'

export function* logIn({ email, password, history }) {
    try {
        const loginResponse = yield call(amplifyAuthentication, { username: email, password })

        localStorage.setItem('willExpire', JSON.stringify(1800 * 1000 + new Date().getTime()))
        localStorage.setItem('cognitoUser', JSON.stringify(loginResponse))
        localStorage.setItem('email', email)
        yield put(AuthActions.logInSuccess())
        history.push('/onboarding')
    } catch (error) {
        if (error.message && error.message.includes('not confirmed')) {
            localStorage.setItem('confirmSignup', JSON.stringify({ email, password }))
            history.push('/confirmSignup', { email, password })
            return
        }

        const errorMessage =
            error?.code === 'NotAuthorizedException'
                ? 'Incorrect email or password. Please try again or contact support@betterspace.uk for assistance. If you don’t already have an account, try signing up first.'
                : ERROR_MESSAGES.default

        yield put(AuthActions.logInFailed(errorMessage))
    }
}

export function* signUp({ email, password, history }) {
    const params = {
        username: email,
        password,
        attributes: {
            email,
        },
    }

    try {
        const signUpResponse = yield call(amplifySignup, params)
        console.log('signUpResponse: ', signUpResponse)
        localStorage.setItem('confirmSignup', JSON.stringify({ email, password }))
        history.replace('/confirmSignup', { email, password })
    } catch (error) {
        if (error?.code === 'UsernameExistsException') {
            const canUserSignInAnswer = yield canUserSignIn(params)

            if (canUserSignInAnswer) {
                /**
                 * If email is already in use AND pwd matches the stored credentials -> Log the user in
                 */
                return history.replace('/login', { email, password })
            } else {
                /**
                 * If email is already in use AND pwd is incorrect -> Continue to signup confirmation screen as if nothing is wrong *
                 */
                localStorage.setItem('confirmSignup', JSON.stringify({ email, password }))
                return history.replace('/confirmSignup', { email, password })
            }
        }

        yield put(AuthActions.signUpFailed(error.message))
    }
}

// TODO Can be moved to fe-lib and reused in W, S, User platforms
async function canUserSignIn({ username, password }) {
    try {
        await amplifyAuthentication({ username, password })
        return true
    } catch (error) {
        console.log('[canUserSignIn error]', error)
        return false
    }
}

export function* callConfirmSignup({ confirmationCode, email, password, history }) {
    try {
        const confirmSignUpResponse = yield call(confirmSignUp, confirmationCode, email)
        console.log('confirmSignUpResponse: ', confirmSignUpResponse)
        yield put(AuthActions.confirmSignUpSuccess())
        if (confirmSignUpResponse) {
            localStorage.removeItem('confirmSignup')
            console.log('confirmSignUpResponse: ', confirmSignUpResponse)
            yield put(AuthActions.logIn(email, password, history))
        } else {
            yield put(AuthActions.confirmSignUpFailed())
        }
    } catch (error) {
        console.log('confirm signup error: ', error)
        yield put(AuthActions.confirmSignUpFailed(error.message))
    }
}

export function* resendCode({ email }) {
    try {
        const resendCodeResponse = yield call(() => Auth.resendSignUp(email))
        if (resendCodeResponse) {
            yield put(AuthActions.resendCodeSuccess())
        } else {
            yield put(AuthActions.resendCodeFailure())
        }
    } catch (error) {
        console.log('resend code error: ', error)
        yield put(AuthActions.resendCodeFailure())
    }
}
